export const toggleDay = (dayId: number, days:any, setDays) => {
    if (days.includes(dayId)) {
      setDays(days.filter((d) => d !== dayId));
    } else {
      setDays([...days, dayId]);
    }
  };
